import { useEffect, useState } from "react";
import api from "@/lib/api";

// Polls `/api/twitch/live` every 60s and returns { live, uptime, channel }.
// Backend caches results for 30s so multiple mounts stay cheap.
export function useTwitchLive(channel) {
    const [state, setState] = useState({ live: false, uptime: null, channel: channel || null });

    useEffect(() => {
        let cancelled = false;
        const load = async () => {
            try {
                const params = channel ? { channel } : {};
                const r = await api.get("/twitch/live", { params });
                if (!cancelled) setState(r.data);
            } catch {
                if (!cancelled) setState((s) => ({ ...s, live: false }));
            }
        };
        load();
        const id = setInterval(load, 60000);
        return () => { cancelled = true; clearInterval(id); };
    }, [channel]);

    return state;
}
